import { render, staticRenderFns } from "./OneSchemaEventImportModal.vue?vue&type=template&id=1f1e27e2&"
import script from "./OneSchemaEventImportModal.vue?vue&type=script&lang=js&"
export * from "./OneSchemaEventImportModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports